import axios from 'axios';
import Environment from '../../../utils/environment';
import { GetReservationParams } from './GetReservationParams';

interface ApiConfig {
  baseURL: string;
  timeout: number;
}

const DEFAULT_API_CONFIG: ApiConfig = {
  baseURL: process.env['REACT_APP_API_ENDPOINT'] as string,
  timeout: 7000,
};

/** 予約情報参照用のAPIを呼び出す。 */
export async function getReservation(params: GetReservationParams) {
  try {
    const config = {
      ...DEFAULT_API_CONFIG,
    };
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    /** axiosのインスタンス。 */
    const instance = axios.create(config);
    /** 本予約APIのパス。 */
    const path = setPath();
    // 本予約APIにPOSTメソッドでリクエストする。
    return await instance.post(path, {...params});
  } catch (err) {
    // エラーが発生した場合、nullを返す。
    return null;
  }
}

/** 環境に応じて呼び出すAPIのパスを切り替える。 */
function setPath() {
  return setTaxiEndpoint('get-reservation-info');
}

export function setTaxiEndpoint(path: string) {
  // 環境に応じてパスを切り替える。
  switch(Environment.getEnvironmentType()) {
    // 本番環境の場合。
    case Environment.PRODUCTION:
      return `/taxi/${path}`;
    // ステージング環境の場合。
    case Environment.STAGING:
      return `/taxi/staging/${path}`;
    // 開発環境または未設定の場合。
    case Environment.DEV:
    default:
      return `/taxi/development/${path}`;
  }
}